const binding = { modules: {}, dataActions: {} };

    (binding.modules['ecomm-theme'] = {
        c: () => require('partner/themes/ecomm-theme/ecomm-theme.tsx'),
        $type: 'themeModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ecomm-theme',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'ecomm-theme.theme.settings.json',
        md: 'src/themes/ecomm-theme'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };